<template>
  <div class="ui center aligned basic segment" id="screen" style="overflow:auto;display:flex;margin:0">
    <div class="ui center aligned container purple segment" style="display:inline-block;margin:auto">
      <h3>Vehicle images</h3>
      
      <div style="max-height:250px;height:auto;overflow:auto">
        <button v-for="(v, index) in vehicles" class="ui yellow label vehicle registration button" style="color:black!important;margin:.5em" :key="index" @click="selectVehicle(index)">{{ v }}</button>
      </div>

      <h3 class="header">{{ selectedReg }}</h3>
      <p>Here you can see both photo shoot images and damage evidence images</p>
      <div class="ui stackable five cards">
        <a :href="$host+'/img/'+selectedReg+'/'+img+'.2.jpg'" target="_blank" class="card" v-for="(img,index) in images" :key="index">
          <div class="image">
            <img :src="$host+'/img/'+selectedReg+'/'+img+'.jpg'">
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        images:[],
        vehicles:[],
        selectedReg:'',
        dts:{
          ps:20,
          skip:0
        }
      };
    },
    methods: {
      loadVehicles() {
        var thiz = this;
        fetch(this.$host+'/pvehicles', {
          method:'POST',
          headers:{'Content-type':'application/json'},
          body:'{}',
          credentials:'include',
          mode:'cors'
        }).then(res=>res.json()).then(res=>{
          if (res.error) {
            console.log('application error #24', res);
          }
          else {
            thiz.vehicles = res.files;
          }
        }).catch(err=>{
          console.log('system error #25', err);
        });
      },
      selectVehicle(index) {
        var thiz = this;
        this.selectedReg = this.vehicles[index];
        fetch(this.$host+'/pvehicles', {
          method:'POST',
          headers:{'Content-type':'application/json'},
          body:JSON.stringify({reg:this.vehicles[index]}),
          credentials:'include',
          mode:'cors'
        }).then(res=>res.json()).then(res=>{
          var i;
          if (res.error) {
            console.log('application error #24', res);
          }
          else {
            for (i=0; i<res.files.length; i++) {
              res.files[i] = res.files[i].replace(".2.jpg", "");
              res.files[i] = res.files[i].replace(".jpg", "");
            }

            for (i=0; i<res.files.length;) {
              if (res.files[i] === res.files[i+1]) {
                res.files.splice(i,1);
              }
              else {
                i++;
              }
            }
            thiz.images = res.files;
          }
        }).catch(err=>{
          console.log('system error #25', err);
        });
      }
    },
    mounted() {
      setTimeout(()=>{
        const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
        e.onfinish = ()=>{
          document.querySelector('#purpleheader').style.height = "130px";
        };
      },0);
      this.loadVehicles();
    }
  }
</script>
